<template>
  <el-form :model="info" :rules="rules" ref="form" class="m-2" label-width="100px">
    <el-form-item label="图片" prop="shop_img">
      <image-uploader v-model="info.shop_img"></image-uploader>
    </el-form-item>
    <el-form-item label="景点名" prop="shop_name">
      <el-input v-model="info.shop_name" placeholder="景点名"></el-input>
    </el-form-item>
    <el-form-item label="简介" prop="shop_intro">
      <el-input v-model="info.shop_intro" placeholder="一句话介绍你的群（最长14个字符）"></el-input>
    </el-form-item>
    <el-form-item label="描述" prop="shop_description">
      <wang-editor v-model="info.shop_description" />
    </el-form-item>
<!--    <el-form-item label="视频">-->
<!--      <video-uploader v-model="info.shop_video"></video-uploader>-->
<!--    </el-form-item>-->
    <el-form-item label="类型" prop="shop_type">
      <el-select v-model="info.shop_type" disabled>
        <el-option :value="6" label="景点"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="电话" prop="shop_phone">
      <el-input v-model="info.shop_phone" placeholder="景点电话"></el-input>
    </el-form-item>
    <el-form-item label="地址" prop="shop_address">
      <el-input v-model="info.shop_address" placeholder="景点地址"></el-input>
    </el-form-item>
    <el-form-item label="时间" prop="shop_business_time">
      <el-input v-model="info.shop_business_hour" placeholder="营业时间"></el-input>
    </el-form-item>
    <el-form-item label="状态" prop="shop_status">
      <el-radio-group v-model="info.shop_status">
        <el-radio :label="1">审核</el-radio>
        <el-radio :label="2">上线</el-radio>
        <el-radio :label="3">下线</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item>
      <el-button @click="()=>$router.back()">返回</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import ImageUploader from '@/components/ImageUploader'
import WangEditor from '@/components/WangEditor'
import VideoUploader from '@/components/VideoUploader'
import CitySelector from '@/components/CitySelector'
import {getShopInfo, updateAddViewInfo} from '@/api/shop'
import store from '@/store'

export default {
  name: 'ViewEdit',
  components: {
    ImageUploader,
    WangEditor,
    VideoUploader,
    CitySelector
  },
  computed: {
    merchantId () {
      return this.$store.state.merchantInfo.id
    },
    userInfo () {
      return store.state.userInfo
    }
  },
  data () {
    const rules = {
      shop_name: [
        { required: true, message: '请输入景点名称', trigger: 'blur' },
        { max: 50, message: '群名不能超过50个字符', trigger: 'blur' }
      ],
      shop_img: [
        { type: 'array', required: true, message: '请上传图片', trigger: 'blur' }
      ],
      shop_description: [
        { required: true, message: '请填写描述', trigger: 'blur' }
      ]
    }
    return {
      rules,
      newTagName: '',
      info: {
        shop_name: '',
        shop_img: [],
        shop_description: '',
        tags: [],
        shop_video: '',
        shop_status: 2
      }
    }
  },
  created () {
    if (this.$route.params.viewId) {
      this.getShopInfo()
    }
  },
  methods: {
    handleNewTagConfirm () {
      if (!this.newTagName.trim().length) {
        return
      }
      this.info.tags.push(this.newTagName)
      this.newTagName = ''
    },
    async getShopInfo () {
      const shopInfo = await getShopInfo(this.$route.params.viewId)
      const imgs = shopInfo.img ? [shopInfo.img] : []
      this.info = {
        shop_id: this.$route.params.viewId,
        shop_img: imgs,
        shop_name: shopInfo.name,
        shop_intro: shopInfo.intro_desc,
        shop_status: shopInfo.status,
        shop_description: shopInfo.description,
        shop_business_hour: shopInfo.business_hour,
        shop_address: shopInfo.address,
        shop_phone: shopInfo.phone,
        shop_type: shopInfo.type,
        city_id: this.userInfo.cur_city.city_id,
        tags: shopInfo.tags
      }
    },
    removeTag (index) {
      this.info.tags.splice(index, 1)
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.$message.error('请检查填写项')
          return
        }
        const info = {
          ...this.info,
          merchant_id: this.merchantId,
          shop_img: this.info.shop_img.pop()
        }
        console.log(info)
        updateAddViewInfo(info)
          .then((res) => {
            this.$message.success('保存成功')
            this.$router.back()
          })
      })
    }
  }
}
</script>
<style lang="scss">
.el-tag + .el-tag {
  margin-left: 10px;
}
.input-new-tag {
  max-width: 60px;
}
</style>




// WEBPACK FOOTER //
// view-edit.vue?330d724b